import { ReactNode } from 'react';
import { ToastNotificationProvider } from '@opswat/ui';
import { SWRProvider } from 'services/swr';
import { UserProvider } from 'services/User';
import { ErrorBoundary } from 'components/ErrorBoundary';

interface WrapRootProps {
    children: ReactNode;
}

export const WrapRoot = ({ children }: WrapRootProps) => {
    // ErrorBoundary is the outermost wrapper so render errors thrown by any
    // provider (including the toast provider) are caught too.
    return (
        <ErrorBoundary>
            <ToastNotificationProvider>
                <UserProvider>
                    <SWRProvider>{children}</SWRProvider>
                </UserProvider>
            </ToastNotificationProvider>
        </ErrorBoundary>
    );
};
